/**
 * 远程设备信息状态管理 Store。
 */
import { create } from "zustand";

export type ScreenResolution = {
	width?: number;
	height?: number;
	[key: string]: unknown;
};

type DeviceStoreState = {
	connectionState: string;
	updateConnectionState: (state: string) => void;
	sessionStatus: Record<string, unknown>;
	updateSessionStatus: (status: Record<string, unknown>) => void;
	screenResolution: ScreenResolution;
	updateScreenResolution: (resolution: ScreenResolution) => void;
};

const useDeviceStore = create<DeviceStoreState>((set) => ({
	connectionState: "new",
	updateConnectionState: (state) => set({ connectionState: state }),

	sessionStatus: {},
	updateSessionStatus: (status) => set({ sessionStatus: status }),

	screenResolution: {},
	updateScreenResolution: (resolution) => set({ screenResolution: resolution }),
}));

export default useDeviceStore;
